
export default {
    "title": "Site",
    "entityName": "site",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "name",
        "descending": false
    },
    filterStorage: {},
    "fields": [
        {
            full:true,
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },
        {
            "value": "country",
            "text": "Country",
            "title": "name",
            "id": "code",
            "type": "autocomplete",
            "readonly": item => { return item.id ? true : false },
            "return_object": true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ],
            render: (item) => {
                return item.country.name + " (" + item.country.code + ")" 
            },
        },

        {
            "value": "country_code",
            "type": "hidden",
        },

        {
            "value": "city",
            "text": "City",
            "type": "text",
            // "readonly": item => { return item.id ? true : false },
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            small:true,
            "value": "index",
            "text": "Index",
            "type": "text",
            "readonly": item => { return item.id ? true : false },
            "validators": [
                "required"
            ],
        },

        {
            small:true,
            "value": "code",
            "text": "Code",
            "type": "text",
            "readonly":true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },

        {
            small:true,
            "value": "factor_level",
            "text": "Factor level",
            "type": "text",
        },

        {
            "full":true,
            "value": "factor_label",
            "readonly":true,
            "text": "Factor label",
            "type": "text",
        },

        {
            "value": "lat",
            "text": "Latitude",
            "type": "text",
        },

        {
            "value": "lon",
            "text": "Longitude",
            "type": "text",
        },

        {
            "full":true,
            "value": "comment",
            "text": "Comment",
            "type": "textarea",
        }


    ],
    "actions": [
    ]
}